<script setup lang="ts">
const items = [
  {
    title: 'Monitoring Kinerja Pengiriman',
    description:
      'Pantau performa setiap ekspedisi, SLA, dan waktu pengantaran melalui visual data interaktif.',
    icon: 'material-symbols:preview'
  },
  {
    title: 'Laporan Keuangan',
    description:
      'Dari pencairan dana COD, Biaya Pengiriman, serta Laporan dana masuk ataupun keluar dapat terlihat secara realtime.',
    icon: 'material-symbols:monitor-outline'
  },
  {
    title: 'Manajemen Tim & Cabang',
    description:
      'Atur akses multi-user, pantau aktivitas staff, dan kontrol proses operasional dengan transparan.',
    icon: 'material-symbols:zoom-out-map'
  },
  {
    title: 'Customer Insight & Repeat Order System',
    description:
      'Identifikasi dan pahami perilaku pelanggan serta tingkatkan retensi dengan data aktual.',
    icon: 'material-symbols:update'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Semua yang Kamu Butuhkan untuk Mengendalikan Operasional Pengiriman"
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
